export default __webpack_public_path__ + "static/media/bannerpay.c7938f9d.webp";